import type { CityConfig } from "../city-template/types";

export const eastpointeConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — marriage license issuance" },
    { label: "Divorce Records — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Eastpointe",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "eastpointe",
  route: "/cities/eastpointe",
  title: "Emergency Passport Eastpointe, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Eastpointe, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Eastpointe, Roseville, Warren, and all Macomb County residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Eastpointe, MI",
  heroSubtitle: "Eastpointe travelers — from the western Macomb County border to Detroit-area commuters to international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Our couriers have direct access to the Detroit Passport Agency. A+ BBB rated courier service serving all of Macomb County and Metro Detroit.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20Michigan%20community%20near%20Detroit%20border%20with%20classic%20mid-century%20homes%20and%20tree-lined%20streets%2C%20quiet%20residential%20neighborhood%20in%20western%20Macomb%20County%2C%20warm%20golden%20afternoon%20light%2C%20well-maintained%20lawns%20and%20American%20suburban%20character%2C%20no%20text%20no%20people%2C%20community%20photography%20with%20a%20sense%20of%20established%20neighborhood%20charm&width=1800&height=700&seq=eastpointe-hero-001&orientation=landscape",
  heroImageAlt: "Eastpointe Michigan suburban neighborhood with classic homes near the Detroit border in Macomb County",
  geoPosition: "42.4684;-82.9555",
  geoPlacename: "Eastpointe, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 20 miles south of Eastpointe — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Eastpointe", zips: "48021" },
    { name: "Roseville", zips: "48066" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Detroit", zips: "48201, 48202, 48203, 48204, 48205, 48206, 48207, 48208, 48209, 48210, 48211, 48212, 48213, 48214, 48215, 48216, 48217, 48219, 48221, 48223, 48224, 48226, 48227, 48228, 48234, 48235, 48238, 48239, 48240" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
    { name: "Fraser", zips: "48026" },
    { name: "Center Line", zips: "48015" },
    { name: "Grosse Pointe", zips: "48230, 48236" },
    { name: "Clinton Township", zips: "48035, 48036, 48038" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Canada Border Travel", desc: "Expertise for Ambassador Bridge and Detroit-Windsor Tunnel crossings" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS or FedEx in Macomb County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Roseville, MI", route: "/cities/roseville-mi" },
    { name: "Emergency passport services in Warren, MI", route: "/cities/warren" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
    { name: "Urgent passport services in Detroit, MI", route: "/cities/detroit" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Eastpointe, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Eastpointe residents can ship from any UPS or FedEx in Macomb County.",
  fpcOfficeDistance: "Serving Eastpointe, Roseville, Warren, Detroit, Saint Clair Shores, Fraser, Center Line, and all of western Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Eastpointe and western Macomb County. From the Gratiot Avenue corridor to the Detroit border, from the eastern edge near Roseville to the northern edge near Warren — we serve all of western Macomb County. Our courier service brings the Detroit Passport Agency directly to your doorstep.",
  nearbyCitiesIntro: "We serve Eastpointe and all western Macomb County communities including Roseville, Warren, Detroit, Saint Clair Shores, Fraser, Center Line, Clinton Township, and Sterling Heights. We also serve travelers crossing the Ambassador Bridge and Detroit-Windsor Tunnel to Canada.",
  howItWorksIntro: "Most Eastpointe travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Eastpointe residents are close to Detroit and often cross to Canada or travel internationally. Here are the most common passport mistakes we see from Eastpointe and western Macomb County travelers.",
  testimonialsIntro: "Eastpointe and western Macomb County travelers — from Detroit commuters to families to international travelers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Eastpointe, MI? Here are the most common ones we hear from western Macomb County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — 20+ miles each way"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Eastpointe and western Macomb County travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and Canada border crossings.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Ambassador Bridge and Detroit-Windsor Tunnel travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Eastpointe adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Eastpointe residents and families — including commuters, families, and new citizens.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Eastpointe and Macomb County residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Eastpointe-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Eastpointe and Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Eastpointe MI", description: "Urgent passport processing for Eastpointe Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Eastpointe MI", description: "Fast passport renewal for Eastpointe Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Eastpointe MI", description: "New passport application services for Eastpointe Michigan residents applying for their first passport." },
    { name: "Child Passport Eastpointe MI", description: "Minor passport services for Eastpointe Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Lisa P.",
      location: "Eastpointe, MI",
      rating: 5,
      text: "Trip to Mexico with my sisters in 4 days and my passport was expired. Fast Passport Center got me renewed in 3 days. I shipped from the FedEx on Gratiot and never had to leave Macomb County. They saved our girls' trip!",
      service: "Passport Renewal",
    },
    {
      name: "Anthony W.",
      location: "Eastpointe, MI",
      rating: 5,
      text: "Work conference in Toronto with 48 hours notice. Fast Passport Center handled my emergency passport in 36 hours. The courier went to the Detroit agency while I kept working. Unbelievably efficient.",
      service: "Emergency Passport",
    },
    {
      name: "Nicole D.",
      location: "Roseville, MI",
      rating: 5,
      text: "First-time passports for my parents before their 50th anniversary cruise. Fast Passport Center made it easy — they reviewed all the documents and got both passports in 5 days. My parents were so impressed.",
      service: "First-Time Passport",
    },
    {
      name: "Mark J.",
      location: "Eastpointe, MI",
      rating: 5,
      text: "Lost my passport the day before a flight to London. Fast Passport Center had a replacement in 48 hours. I honestly thought I was going to miss my flight. These guys are lifesavers.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "eastpointe-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20 miles south of Eastpointe — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "eastpointe-2",
      name: "Eastpointe Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21400 Gratiot Ave",
      city: "Eastpointe",
      state: "MI",
      zip: "48021",
      phone: "(586) 777-8890",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Eastpointe — on Gratiot Avenue near 8 Mile Road",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Eastpointe acceptance facility. Convenient for Eastpointe and the western Macomb County border. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "eastpointe-3",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27300 Gratiot Ave",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 777-8880",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Roseville — approximately 3 miles east of Eastpointe",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Eastpointe and Roseville residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "eastpointe-4",
      name: "Warren Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28400 Mound Rd",
      city: "Warren",
      state: "MI",
      zip: "48092",
      phone: "(586) 573-1220",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Warren — approximately 5 miles north of Eastpointe",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Warren and western Macomb County residents. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
    {
      id: "eastpointe-5",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling Heights — approximately 12 miles north of Eastpointe",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macomb County residents including Sterling Heights, Shelby Township, and Utica. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must drive 20+ miles to downtown", fpc: "No — ship from anywhere in Macomb County" },
    { feature: "Canada Border Expertise", agency: "No tailored advice", fpc: "Yes — Ambassador Bridge, Windsor Tunnel, and Canada travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Eastpointe commuters and families often discover passport issues right before travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel to Canada",
      description: "Many Eastpointe residents crossing to Windsor use a passport card or enhanced license — but these are not valid for air travel. If you fly to Canada, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Macomb County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Canada Entry Requirements",
      description: "Canada has its own entry requirements separate from passport validity. Ambassador Bridge and Detroit-Windsor Tunnel travelers should verify current Canadian customs and immigration rules before crossing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in western Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Eastpointe, Roseville, or Warren." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Macomb County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport acceptance facility in Eastpointe, MI?", a: "The Eastpointe Post Office at 21400 Gratiot Ave is the primary acceptance facility in Eastpointe. The Roseville Post Office at 27300 Gratiot Ave and the Warren Post Office at 28400 Mound Rd are also nearby. All require appointments. Fast Passport Center eliminates the need for an in-person visit — our couriers handle everything." },
    { q: "How fast can I get an emergency passport in Eastpointe, MI?", a: "Fast Passport Center offers emergency passport processing in Eastpointe, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 20+ miles to downtown Detroit." },
    { q: "Do I need a passport to cross the Ambassador Bridge to Canada?", a: "For air travel to Canada, yes — you need a passport book. For land crossings via the Ambassador Bridge, Detroit-Windsor Tunnel, or Blue Water Bridge, U.S. citizens can use a passport book, passport card, enhanced driver's license, or Trusted Traveler card. A passport book provides the most flexibility for all types of travel." },
    { q: "Can I get an expedited passport in the western Macomb County suburbs?", a: "Absolutely. Fast Passport Center serves all of western Macomb County including Eastpointe, Roseville, Warren, Detroit, Saint Clair Shores, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do western Macomb County travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for western Macomb County residents, approximately 25–30 minutes from Eastpointe. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. Windsor Airport (YQG) is a secondary option. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Eastpointe, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Eastpointe residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Macomb County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve all of western Macomb County?", a: "Yes. Fast Passport Center serves all of western Macomb County including Eastpointe, Roseville, Warren, Detroit, Saint Clair Shores, Fraser, and Center Line. Our courier service is especially valuable for busy commuters who don't have time to drive to downtown Detroit." },
  ],
  photoLocations: [
    { name: "Walgreens — Eastpointe", address: "20000 E 8 Mile Rd, Eastpointe, MI 48021", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Roseville", address: "29500 Gratiot Ave, Roseville, MI 48066", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Warren", address: "28400 Mound Rd, Warren, MI 48092", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Sterling Heights", address: "37100 Van Dyke Ave, Sterling Heights, MI 48312", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Eastpointe", address: "20000 Gratiot Ave, Eastpointe, MI 48021", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves western Macomb County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Warren", address: "28400 Mound Rd, Warren, MI 48092", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Warren and northern Macomb County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "25–30 minutes from Eastpointe via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "35–40 minutes from Eastpointe via I-94 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Macomb County travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};